//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    album: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      
    }
  },

  created () {
    // console.log(this.album)
  },

  methods: {
    clickAlbumItem () {
      this.$emit('click-album', this.album)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/xc_time/AlbumItem.vue